import * as Yup from 'yup';
import { FormikProps } from 'formik';
import { getTouchedConfigForValidatingFields } from './getTouchedConfigForValidatingFields';

export const validateForm = async <T>(
  objectScheme: Yup.AnyObjectSchema,
  formik: FormikProps<T>
): Promise<boolean> => {
  const touchedConfig = getTouchedConfigForValidatingFields(objectScheme);
  await formik.setTouched(touchedConfig);

  const errors = await formik.validateForm();

  const isValid = Object.keys(errors).length === 0;
  return isValid;
};
